import {
    RESET_STATE,

    LISTAGEM_PEDIDO_LOADING,
    LISTAGEM_PEDIDO,
    LISTAGEM_PEDIDO_ERRO,

    DETALHAMENTO_PEDIDO_LOADING,
    DETALHAMENTO_PEDIDO,
    DETALHAMENTO_PEDIDO_ERRO
} from '../types/PedidoType';

const initialState = {
    listagem_pedido_loading: null,
    listagem_pedido: null,
    listagem_pedido_erro: null,

    detalhamento_pedido_loading: null,
    detalhamento_pedido: null,
    detalhamento_pedido_erro: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case RESET_STATE:
            return initialState;
        case LISTAGEM_PEDIDO_LOADING:
            return {
                ...state,
                listagem_pedido_loading: action.payload
            }
        case LISTAGEM_PEDIDO:
            return {
                ...state,
                listagem_pedido_loading: false,
                listagem_pedido: action.payload,
                listagem_pedido_erro: null
            }
        case LISTAGEM_PEDIDO_ERRO:
            return {
                ...state,
                listagem_pedido_loading: false,
                listagem_pedido: null,
                listagem_pedido_erro: action.payload
            }
        case DETALHAMENTO_PEDIDO_LOADING:
            return {
                ...state,
                detalhamento_pedido_loading: action.payload
            }
        case DETALHAMENTO_PEDIDO:
            return {
                ...state,
                detalhamento_pedido_loading: false,
                detalhamento_pedido: action.payload,
                detalhamento_pedido_erro: null
            }
        case DETALHAMENTO_PEDIDO_ERRO:
            return {
                ...state,
                detalhamento_pedido_loading: false,
                detalhamento_pedido: null,
                detalhamento_pedido_erro: action.payload
            }
        default:
            return state;
    }
}